import { SimpleChipExpression, GroupChipExpression, ExpertChipExpression } from "@nrwl/query-emitter";

export interface IChipRemovalDecisionMaker {
  shouldRemoveChip(chip: SimpleChipExpression, trimLogicalOp: boolean):boolean;
}

interface IChipProcessingOutcome {
  chipReplacement: any
}

export class AlterChipExpressionService {

  // method attempts removal of 1 = 1 expressions (for me, that's redundant work. Any
  // sensible SQL engine implementation will take care to remove them before applying
  // SQL where conditions..)
  static removePlaceholders(chips: (SimpleChipExpression | GroupChipExpression)[], decision: IChipRemovalDecisionMaker):(SimpleChipExpression | GroupChipExpression)[] {
    if (!chips) {
      return chips;
    }
    const result = [];

    for (let chip of chips) {
      if (chip.isGroup) {
        const groupProcessResult = AlterChipExpressionService.processGroupChip(chip as GroupChipExpression, decision);
        chip = groupProcessResult.chipReplacement;
        if (!chip) {
          // all chips from this group are gone, so simply proceed with others
          continue;
        }
      }

      // once we have dealt with group chip, we can treat it as simple chip
      if (decision.shouldRemoveChip(chip as SimpleChipExpression, null)) {
      }
      else {
        if (result.length === 0) {
          (chip as ExpertChipExpression).logicalOp = undefined;
        }
        result.push(chip);
      }
    }
    return result;
  }

  static processGroupChip(chip: GroupChipExpression, decision: IChipRemovalDecisionMaker): IChipProcessingOutcome {
    const result: IChipProcessingOutcome = {
      chipReplacement: chip
    }
    // apply recursion to clean up placeholders and unnecessary (..) expressions
    const innerExpression = AlterChipExpressionService.removePlaceholders((chip as GroupChipExpression).group, decision);

    switch (innerExpression.length) {
      case 0: {
        // expression has no members. Thus it can be simply removed
        result.chipReplacement = null;
      }
        break;
      case 1: {
        // (..) expression has just one chip - lets drop the (..) and return chip itself
        const extractedChip = innerExpression[0];
        // make sure to copy logical operation from (..) expression to extracted chip
        (extractedChip as ExpertChipExpression).logicalOp = chip.logicalOp;
        result.chipReplacement = extractedChip;
      }
        break;
      default: {
        // the (..) has multiple chips - just update the array with possibly cleaned chips
        (chip.group as unknown) = innerExpression;
      }
        break;
    }
    return result;
  }

}
